function lengthValidator(input) {
  const isValid = input.length > 0;

  return isValid;
}

export default lengthValidator;
